import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "1.625",
  y: "13.18",
  width: "15.878",
  height: "4.731",
  rx: "2.366",
  fill: "#525052",
  "fill-opacity": ".45",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24.07 16.943c-3.38-1.01-4.446-4.86-4.59-7.003a.389.389 0 0 0-.384-.366.375.375 0 0 0-.375.375v6.587a1 1 0 0 0 1 1h4.275c.164 0 .298-.032.298-.197 0-.137-.094-.357-.225-.396ZM3.044 10.76l1.228-5.962A1 1 0 0 1 5.252 4h8.576a1 1 0 0 1 1 1v3.822c0 .415.337.752.752.752s.752.336.752.752v.636a1 1 0 0 1-1 1H4.023a1 1 0 0 1-.98-1.202Z",
  fill: "#525052",
  "fill-opacity": ".45",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.834 5.967h5.313c.345 0 .625.28.625.625v1.981c0 .346-.28.625-.625.625h-5.73a.625.625 0 0 1-.611-.753l.417-1.981a.625.625 0 0 1 .611-.497Z",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.685 15.545a.694.694 0 1 1-1.389 0 .694.694 0 0 1 1.389 0ZM10.258 15.545a.694.694 0 1 1-1.388 0 .694.694 0 0 1 1.388 0ZM15.832 15.545a.694.694 0 1 1-1.389 0 .694.694 0 0 1 1.389 0Z",
  stroke: "#D5D4D6"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }